import React from "react";
import { useSelector } from "react-redux";
import { Button, Modal } from "semantic-ui-react";
import MachineSessionModalAction from "@common/redux/actions/MachineSessionModalAction";
import SessionalDetailsAction from "@common/redux/actions/SessionalDetailsAction";
import SessionsDetails from "@common/components/shared/SessionsDetails";
import Flex from "@common/components/shared/Flex";
import { useSessions } from "../hooks/useSessions";
import {
  handleRowClickOptionChange,
  handleSessionsRowClick,
} from "../helpers/Sessions/sessionsDetailsHelpers";
import useLogin from "../hooks/useLogin";

const MachineSessionModal = () => {
  const { open, selectedSessionDetails } = useSelector((state) =>
    MachineSessionModalAction.getStatePath(state),
  );
  const [{ optionDisplaySessionsInCompliance }] = useLogin();

  const { grid } = useSelector((state) =>
    SessionalDetailsAction.getStatePath(state),
  );

  const handleRefresh = useSessions(true, open);

  return (
    <>
      <Modal
        open={open}
        onClose={() => MachineSessionModalAction.onClose(false)}
        size="large"
        centered={false}
      >
        <Modal.Header>
          Link Session
          <Button
            type="button"
            floated="right"
            color="green"
            icon="refresh"
            onClick={handleRefresh}
          />
        </Modal.Header>
        <Modal.Content
          style={{
            height: `${optionDisplaySessionsInCompliance ? "800px" : "500px"}`,
          }}
        >
          <Flex>
            <SessionsDetails
              hideShowEvents={true}
              showAlertFilter={false}
              onDetailClick={(row) => {
                const newGridData = handleRowClickOptionChange(grid.data, row);
                handleSessionsRowClick(row, newGridData);
              }}
              shortTerm={true}
            />
          </Flex>
        </Modal.Content>
        <Modal.Actions>
          <Button
            type="button"
            floated="left"
            onClick={() => MachineSessionModalAction.onClose(false)}
          >
            Close
          </Button>
          <Button
            type="button"
            disabled={selectedSessionDetails === null}
            positive
            onClick={() => {
              MachineSessionModalAction.onClose(true);
            }}
          >
            Submit
          </Button>
        </Modal.Actions>
      </Modal>
    </>
  );
};

export default MachineSessionModal;
